module.exports = __webpack_public_path__ + "img/qrcode-icon.48adc53c.png";